import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OptionDetailsTaggingResolverService implements Resolve<any> {
  constructor() {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> | any {
    const productType = route.paramMap.get('productType');
    // set the category L3 based on productType path param
    route.data.analytics.page.category.l3 = productType + ' options ordering';
    route.data.analytics.page.id =
      'myproducts ' + productType + ' options ordering';
    route.data.analytics.page.name =
      'myproducts ' + productType + ' options ordering';
    return route.data.analytics.page.category.l3;
  }
}
